import _asyncToGenerator from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _toConsumableArray from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { get, pick, uniq, isEmpty } from 'lodash';
import URI, { parseQuery } from 'urijs';
import * as sizes from './sizes';
import OAuthWindowBase from './base';
export var settings = 'scrollbars=no,toolbar=no,location=no,titlebar=no,directories=no,status=no,menubar=no';
export function normalizeTokenKeys(params) {
  // normalize keys
  if (params.token) {
    params['access-token'] = params.token;
    delete params.token;
  }

  if (params.auth_token) {
    params['access-token'] = params.auth_token;
    delete params.auth_token;
  }

  if (params.client_id) {
    params.client = params.client_id;
    delete params.client_id;
  }

  if (params.config) {
    params.endpointKey = params.config;
    delete params.config;
  }

  return params;
}
export function getPopupOffset(_ref) {
  var width = _ref.width,
      height = _ref.height,
      _ref$w = _ref.w,
      w = _ref$w === void 0 ? window : _ref$w;
  var wLeft = w.screenLeft ? w.screenLeft : w.screenX;
  var wTop = w.screenTop ? w.screenTop : w.screenY;
  var left = wLeft + w.innerWidth / 2 - width / 2;
  var top = wTop + w.innerHeight / 2 - height / 2;
  return {
    top: top,
    left: left
  };
}
export function getPopupDimensions(provider) {
  var w = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  var _get = get(sizes, provider, {
    width: 1020,
    height: 618
  }),
      width = _get.width,
      height = _get.height;

  var _getPopupOffset = getPopupOffset({
    width: width,
    height: height,
    w: w
  }),
      top = _getPopupOffset.top,
      left = _getPopupOffset.left;

  return "width=".concat(width, ",height=").concat(height, ",top=").concat(top, ",left=").concat(left);
}
export function openPopup(_ref2) {
  var url = _ref2.url,
      provider = _ref2.provider,
      _ref2$w = _ref2.w,
      w = _ref2$w === void 0 ? window : _ref2$w;
  var uri = URI(url).addSearch('auth_origin_url', w.location.href).addSearch('blank', true);
  return w.open(uri.toString(), provider, "".concat(settings, ",").concat(getPopupDimensions(provider, w)));
}
export function parseLocationCreds(_ref3) {
  var uri = _ref3.uri,
      headerKeys = _ref3.headerKeys;
  var params = normalizeTokenKeys(parseQuery(uri.query()));
  return pick(params, uniq(_toConsumableArray(headerKeys)));
}
export function parseLocationError(uri) {
  var params = parseQuery(uri.query());
  return pick(params, ['error']);
}
export function waitForOAuth(_ref4) {
  var url = _ref4.url,
      provider = _ref4.provider,
      popup = _ref4.popup,
      promise = _ref4.promise,
      resolve = _ref4.resolve,
      reject = _ref4.reject,
      headerKeys = _ref4.headerKeys,
      _ref4$w = _ref4.w,
      w = _ref4$w === void 0 ? window : _ref4$w;
  // avoid param reassignment
  var errors;
  var creds;

  if (!popup) {
    popup = openPopup({
      url: url,
      provider: provider,
      w: w
    });
  }

  if (!promise) {
    promise = Promise(function (res, rej) {
      resolve = res;
      reject = rej;
    });
  }

  if (!popup) {
    return reject('Popup was blocked. Please disable your popup blocker for this site.');
  }

  if (popup.closed) {
    return reject('Popup was closed before connection was completed.');
  } // the following methods will throw errors while the popup is away from our
  // domain and on the provider site. these errors should be ignored.


  try {
    var uri = URI(popup.location.href);
    errors = parseLocationError(uri);
    creds = parseLocationCreds({
      uri: uri,
      headerKeys: headerKeys
    });
  } catch (_) {// popup has left our domain. no-op
  }

  if (!isEmpty(creds)) {
    popup.close();
    resolve(creds);
  }

  if (!isEmpty(errors)) {
    popup.close();
    return reject(errors);
  }

  if (isEmpty(creds)) {
    setTimeout(function () {
      return waitForOAuth({
        url: url,
        provider: provider,
        popup: popup,
        promise: promise,
        resolve: resolve,
        reject: reject,
        headerKeys: headerKeys
      });
    }, 100);
  }

  return promise;
}

var OAuthBrowserWindow = /*#__PURE__*/function (_OAuthWindowBase) {
  _inherits(OAuthBrowserWindow, _OAuthWindowBase);

  var _super = _createSuper(OAuthBrowserWindow);

  function OAuthBrowserWindow() {
    _classCallCheck(this, OAuthBrowserWindow);

    return _super.apply(this, arguments);
  }

  _createClass(OAuthBrowserWindow, [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var w,
            creds,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                w = _args.length > 0 && _args[0] !== undefined ? _args[0] : window;
                _context.prev = 1;
                _context.next = 4;
                return waitForOAuth({
                  provider: this.provider,
                  url: this.url,
                  promise: this.hasAuthenticated,
                  resolve: this.resolve,
                  reject: this.reject,
                  headerKeys: this.headerKeys,
                  w: w
                });

              case 4:
                creds = _context.sent;
                this.session.set(creds);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                throw _context.t0;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 8]]);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }]);

  return OAuthBrowserWindow;
}(OAuthWindowBase);

export { OAuthBrowserWindow as default };